var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.125H7.0625C6.48234 6.125 5.92594 5.89453 5.5157 5.4843C5.10547 5.07406 4.875 4.51766 4.875 3.9375C4.875 3.35734 5.10547 2.80094 5.5157 2.3907C5.92594 1.98047 6.48234 1.75 7.0625 1.75C10.125 1.75 11 6.125 11 6.125Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.125H14.9375C15.5177 6.125 16.0741 5.89453 16.4843 5.4843C16.8945 5.07406 17.125 4.51766 17.125 3.9375C17.125 3.35734 16.8945 2.80094 16.4843 2.3907C16.0741 1.98047 15.5177 1.75 14.9375 1.75C11.875 1.75 11 6.125 11 6.125Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.125L11 19.25",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.25H19.75",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 19.25C17.9301 19.25 18.4201 19.25 18.7945 19.0593C19.1238 18.8915 19.3915 18.6238 19.5593 18.2945C19.75 17.9201 19.75 17.4301 19.75 16.45V8.925C19.75 7.94491 19.75 7.45486 19.5593 7.08052C19.3915 6.75123 19.1238 6.48352 18.7945 6.31574C18.4201 6.125 17.9301 6.125 16.95 6.125L5.05 6.125C4.06991 6.125 3.57986 6.125 3.20552 6.31574C2.87623 6.48352 2.60852 6.75123 2.44074 7.08052C2.25 7.45486 2.25 7.94491 2.25 8.925L2.25 16.45C2.25 17.4301 2.25 17.9201 2.44074 18.2945C2.60852 18.6238 2.87623 18.8915 3.20552 19.0593C3.57986 19.25 4.06991 19.25 5.05 19.25L16.95 19.25Z",
    stroke: "#475467",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.69a5a028d2aeb5fa4bae8095831a7cb8.svg";
export { ForwardRef as ReactComponent };